export default function getRandomInt(min, max, nonZero = false) {
    let a = Math.floor(Math.random() * (max - min + 1)) + min;
    if (nonZero) {
        if (Math.random() > .5) {
            return getRandomInt(min, max);
        }
        else {
            return -1 * getRandomInt(min, max);
        }
    }
    else {
        return a;
    }
}
